<div class="mt-6">
  <shared-title class="text-center">
    @if (issParking() === 1) {
      Información del parqueo
    } @else {
      Información del puesto de trabajo
    }
  </shared-title>
  <div class="text-center">
    <mat-label>
      @if (issParking() === 1) {
        Día en los que esta disponible este parqueo:
      } @else {
        Día en los que esta disponible este puesto de trabajo:
      }
    </mat-label>
    <div class="flex justify-content-center flex-column">
      <mat-selection-list class="flex justify-content-center">
        <div class="checkbox-item">
          <mat-checkbox [checked]="monday_" [disabled]="true"></mat-checkbox>
          <div>L</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="tuesday_" [disabled]="true"></mat-checkbox>
          <div>M</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="wednesday_" [disabled]="true"></mat-checkbox>
          <div>M</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="thursday_" [disabled]="true"></mat-checkbox>
          <div>J</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="friday_" [disabled]="true"></mat-checkbox>
          <div>V</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="saturday_" [disabled]="true"></mat-checkbox>
          <div>S</div>
        </div>
        <div class="checkbox-item">
          <mat-checkbox [checked]="sunday_" [disabled]="true"></mat-checkbox>
          <div>D</div>
        </div>
      </mat-selection-list>
    </div>
  </div>
  <div class="flex justify-content-center flex-column">
    <div
      class="flex justify-content-between ml-8 mr-8 flex-column sm:flex-column md:flex-row lg:flex-row xl xl:flex-row">
      <mat-dialog-content class="flex justify-content-center flex-column">
        <mat-label>Nombre: {{ data.action.name }}</mat-label>
        <mat-label>Codigo: {{ data.action.code }}</mat-label>
        <mat-label>Descripción: {{ data.action.description }}</mat-label>
        <mat-label>Telefono: {{ data.action!.phone }}</mat-label>
        <mat-label>Coordenada X: {{ data.action.x }}</mat-label>
        <mat-label>Coordenada Y: {{ data.action.y }}</mat-label>
        <mat-label>Tipo de puesto de trabajo: {{ dataTypeJob.name }}</mat-label>
        <mat-label>Grupo de lugar de trabajo: {{ dataGroup.name }}</mat-label>
      </mat-dialog-content>

      <qrcode
        #parent
        class="flex justify-content-center"
        (qrCodeURL)="onChangeURL($event)"
        [qrdata]="data.action.workplaceid"
        [width]="256"
        [errorCorrectionLevel]="'M'" />
    </div>

    <mat-dialog-actions
      class="flex justify-content-center sm:justify-content-center md:justify-content-evenly lg:justify-content-evenly xl:justify-content-evenly pb-6 flex-column gap-3 sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      @if (isSysAdmin) {
        <button
          (click)="reserve()"
          [routerLink]="['/admin/reservations/create-reservations']"
          mat-raised-button
          class="green-button">
          Reservar<mat-icon>assignment</mat-icon>
        </button>
      }
      <shared-button
        (click)="editJob(data.action)"
        class="flex"
        [icon]="'create'"
        [typeBtn]="'button'"
        [color]="'accent'"
        >Editar</shared-button
      >
      <shared-button
        (click)="modalDelete(data.action)"
        class="flex"
        [icon]="'delete'"
        [typeBtn]="'button'"
        [color]="'warn'"
        >Eliminar</shared-button
      >
      <shared-button
        (click)="dowloandQr()"
        class="flex"
        [routerLink]="['admin/pdf']"
        [icon]="'cloud_download'"
        [typeBtn]="'button'"
        [color]="'accent'"
        >Descargar QR</shared-button
      >
      <button mat-raised-button mat-dialog-close>
        <mat-icon>clear</mat-icon>
        Cerrar
      </button>
    </mat-dialog-actions>
  </div>
</div>
